export default __webpack_public_path__ + "static/blog4-467ebe49ce71efee25016fe476fb113c.jpg";